import ENV from "./Environment";
import Requests from "./Requests";

const baseUrl = `${ENV.base_url}/api/v1/evaluations/runs`;

const getRuns = async (userData, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({ page, page_size: pageSize });
  const response = await Requests.getRequest(`${baseUrl}?${params}`, userData.jwtToken, userData);
  if (!response || !response.ok) throw new Error("Unable to load pre-enrichment runs.");
  const data = await response.json();
  if (!Array.isArray(data?.runs) || !Number.isInteger(data?.pagination?.total_pages) || data.pagination.total_pages < 0) {
    throw new Error("The pre-enrichment runs response was invalid.");
  }
  return data;
};

const getRun = async (userData, id) => {
  const response = await Requests.getRequest(`${baseUrl}/${encodeURIComponent(id)}`, userData.jwtToken, userData);
  if (!response || !response.ok) throw new Error("Unable to load run details.");
  const data = await response.json();
  if (!data || data.id !== id) throw new Error("The run details response was invalid.");
  return data;
};

const getRunDocuments = async (userData, runId, page = 1, pageSize = 10) => {
  const params = new URLSearchParams({ page, page_size: pageSize });
  const url = `${ENV.base_url}/api/v1/evaluations/documents/${encodeURIComponent(runId)}?${params}`;
  const response = await Requests.getRequest(url, userData.jwtToken, userData);
  if (!response || !response.ok) throw new Error("Unable to load run documents.");
  const data = await response.json();
  if (!Array.isArray(data?.documents) || !Number.isInteger(data?.pagination?.total_pages) || data.pagination.total_pages < 0) {
    throw new Error("The run documents response was invalid.");
  }
  return data;
};

const getRunDocument = async (userData, runId, documentId) => {
  const url = `${ENV.base_url}/api/v1/evaluations/${encodeURIComponent(runId)}/document/${encodeURIComponent(documentId)}`;
  const response = await Requests.getRequest(url, userData.jwtToken, userData);
  if (!response || !response.ok) throw new Error("Unable to load document details.");
  const data = await response.json();
  if (data?.run_id !== runId || data?.document?.document_id !== documentId) {
    throw new Error("The document details response was invalid.");
  }
  return data;
};

const getRulesets = async (userData) => {
  const response = await Requests.getRequest(`${ENV.base_url}/api/v1/rulesets`, userData.jwtToken, userData);
  if (!response || !response.ok) throw new Error("Unable to load pre-enrichment rulesets.");
  const data = await response.json();
  if (!Array.isArray(data?.rulesets)) throw new Error("The rulesets response was invalid.");
  return data;
};

const getRulesetRules = async (userData, rulesetId) => {
  const response = await Requests.getRequest(`${ENV.base_url}/api/v1/rulesets/${encodeURIComponent(rulesetId)}/rules`, userData.jwtToken, userData);
  if (!response || !response.ok) throw new Error("Unable to load rules and derivations.");
  const data = await response.json();
  if (data?.id !== rulesetId || !Array.isArray(data?.rules) || !Array.isArray(data?.derivations)) {
    throw new Error("The ruleset rules response was invalid.");
  }
  return data;
};

const AIPreEnrichmentService = { getRuns, getRun, getRunDocuments, getRunDocument, getRulesets, getRulesetRules };
export default AIPreEnrichmentService;
